import { ObjectUtil }               from "@/services/";
import BaseHomeContent              from "@/components/BaseHomeContent";
import AccountDetails               from "@/components/AccountDetails/AccountDetails";
import WarehouseShippingOptions     from "@/components/AccountDetails/WarehouseShippingOptions";
import AddressBookList              from "@/components/AccountDetails/AddressBookList";
import { UserSettings }             from "@/components/AccountDetails/UserSettings";

import PartsCatalog                 from "@/components/Catalog/PartsCatalog";
import CatalogSearch                from "@/components/Catalog/CatalogSearch";
import CatalogListing               from "@/components/Catalog/CatalogListing";
import PartsStoreOrders             from "@/components/PartsStore/Orders/PartsStoreOrders";
import PartsStoreOrderDetails       from "@/components/PartsStore/Orders/PartsStoreOrderDetails";
import ReverseLogistics             from "@/components/ReverseLogistics/ReverseLogistics";
import ViewClaims                   from "@/components/ReverseLogistics/Claims/ViewClaims";
import ClaimsReturnsSearchResults   from "@/components/ReverseLogistics/Claims/ClaimsReturnsSearchResults";
import CreateClaim                  from "@/components/ReverseLogistics/Claims/CreateClaim";
import ViewReturns                  from "@/components/ReverseLogistics/Returns/ViewReturns";
import ClaimDetails                 from "@/components/ReverseLogistics/Claims/ClaimDetails";
import ClaimsReturnsMenu            from "@/components/ReverseLogistics/ClaimsReturnsMenu";
import CreateReturn                 from "@/components/ReverseLogistics/Returns/CreateReturn";
import ReturnDetails                from "@/components/ReverseLogistics/Returns/ReturnDetails";
import { 
    Entitlements,
    CorePurchaseRequest,
    CcrRequestForm,
    CompleteCoreCreditRequest, 
    OpenCoreCreditRequests,
    CoreCredits }        from "@/components/ReverseLogistics/Entitlements";

import { PartSearchPage }           from "@/components/PartSearch";
import {
    Orders,
    OrderDetails,
    OrdersSearchResults,
    QuickOrders }                   from "@/components/Orders";
import {
    Invoices,
    InvoiceDetails }                from "@/components/Invoices";
import { ResourceLibrary }          from "@/components/ResourceLibrary";
import {
    Credits,
    CreditDetails }                 from "@/components/Credits";
import { Backorders }               from "@/components/Backorders";
import { News }                     from "@/components/News";
import { Promotion }                from "@/components/Promotion";
import { PartDetails }              from "@/components/PartDetail";
import {
    TruckSelection,
    TmsIndex }                      from "@/components/TruckModelSearch";
import {
    PartDiagramPage }               from "@/components/PartDiagramSearch";
import { Cart }                     from "@/components/Cart";
import  ShoppingCartThankYou        from "@/components/Cart/ShoppingCartThankYou/ShoppingCartThankYou.vue";
import VueRouter                    from "vue-router";


const routes = [
    {
        path: "/",
        component: BaseHomeContent,
        name: "Home",
        //No breadcrumbs on this page
    },
    {
        path: "/home",
        component: BaseHomeContent
    },
    {
        path: "/Catalog/Index",
        component: PartsCatalog,
        name: "PartsCatalogIndex",
        meta: {
            breadcrumb: [
                { name: "Home", localizationKey: "homeButton", link: "/" },
                { name: "Parts Catalog", link: "/Catalog/Index" },
            ],
        },
    },
    {
        path: "/Catalog/Search",
        component: CatalogSearch,
        name: "CatalogSearch",
        meta: {
            breadcrumb: [
                { name: "Home", localizationKey: "homeButton", link: "/" },
                { name: "Parts Catalog", link: "/Catalog/Index" },
                { name: "Parts Search", link: "/Catalog/Search" },
            ],
        },
    },
    {
        path: "/catalog/catalogListing",
        component: CatalogListing,
        name: "CatalogListing",
        props: (route) => ({
            currentCategoryId: route.query.currentCategoryId
        }),
        meta: {
            breadcrumb: [
                { name: "Home", localizationKey: "homeButton", link: "/" },
                { name: "Catalog", link: "/Catalog/Index" },
            ],
        },
    },
    {
        path: "/account/accountdetails",
        component: AccountDetails,
        name: "AccountDetails",
        meta: {
            breadcrumb: [
                { name: "Home", localizationKey: "homeButton", link: "/" },
                { name: "My Account", link: "AccountDetails" },
                {
                    name: "Account Details",
                    localizationKey: "accountDetailsMenu",
                    link: "",
                }, //leaving this blank signifies this is the page we're currently on, nothing to link to
            ],
        },
    },
    {
        path: "/account/userSettings",
        component: UserSettings,
        name: "UserSettings",
        meta: {
            breadcrumb: [
                { name: "Home", localizationKey: "homeButton", link: "/" },
                { name: "My Account", link: "AccountDetails" },
                { 
                    name: "User Setttings", 
                    localizationKey: "userSettings", 
                    link: "" 
                },
            ],
        },
    },
    {
        path: "/account/addressbooklist",
        component: AddressBookList,
        name: "AddressBookList",
        meta: {
            breadcrumb: [
                { name: "Home", localizationKey: "homeButton", link: "/" },
                { name: "My Account", link: "AccountDetails" },
                { name: "Address Book", localizationKey: "addressBookMenu", link: "" },
            ],
        },
    },
    {
        path: "/account/warehouseShippingOptions",
        component: WarehouseShippingOptions,
        name: "WarehouseShippingOptions",
        meta: {
            breadcrumb: [
                { name: "Home", localizationKey: "homeButton", link: "/" },
                { name: "My Account", link: "AccountDetails" },
                {
                    name: "Warehouse Shipping Options",
                    localizationKey: "warehouseShippingOptionsMenu",
                    link: "",
                }, //leaving this blank signifies this is the page we're currently on, nothing to link to
            ],
        },
    },
    {
        path: "/Orders/OpenOrders",
        component: Orders,
        name: "Orders",
        meta: {
            breadcrumb: [
                { name: "Home", localizationKey: "homeButton", link: "/" },
                { name: "Orders", localizationKey: "ordersButton", link: "" },
            ],
        },
    },
    {
        path: "/orders/details",
        component: OrderDetails,
        name: "OrderDetails",
        props: (route) => ({
            orderNumber: route.query.orderNumber,
            orderSource: route.query.orderSource,
            dealerCode: route.query.dealerCode,
            salesOrg: route.query.salesOrg,
        }),
        meta: {
            breadcrumb: [
                { name: "Home", localizationKey: "homeButton", link: "/" },
                { name: "Orders", link: "/Orders/OpenOrders" },
                { name: "Details", link: "" },
            ],
        },
    },
    {
        path: "/orders/invoices",
        component: Invoices,
        name: "Invoices",
        meta: {
            breadcrumb: [
                { name: "Home", localizationKey: "homeButton", link: "/" },
                { name: "Invoices", localizationKey: "invoicesButton", link: "" },
            ],
        },
    },
    {
        path: "/orders/search",
        component: OrdersSearchResults,
        name: "OrderSearch",
        props: (route) => ({
            documentNumber: route.query.documentNumber,
            partNumber: route.query.partNumber,
            dealerCode: route.query.dealerCode,
            dealerFilter: route.query.dealerFilter
        }),
        meta: {
            breadcrumb: [{ name: "Home", localizationKey: "homeButton", link: "/" }, { name: "Search", link: "" }],
        },
    },
    {
        path: "/orders/invoices/detail",
        component: InvoiceDetails,
        name: "InvoiceDetails",
        props: (route) => ({
            invoiceId: route.query.invoiceId,
            invoiceSource: route.query.invoiceSource,
        }),
        meta: {
            breadcrumb: [
                { name: "Home", localizationKey: "homeButton", link: "/" },
                { name: "Invoices", link: "/orders/invoices" },
                { name: "Details", link: "" },
            ],
        },
    },
    {
        path: "/orders/credits",
        component: Credits,
        name: "Credits",
        meta: {
            breadcrumb: [
                { name: "Home", localizationKey: "homeButton", link: { name: "Home" } },
                { name: "Credits", localizationKey: "creditsButton", link: "" },
            ],
        },
    },
    {
        path: "/orders/credits/detail",
        component: CreditDetails,
        name: "CreditDetails",
        props: (route) => ({
            id: route.query.id,
            invoiceNumber: route.query.invoiceNumber,
            orderNumber: route.query.orderNumber,
            dealerCode: route.query.dealerCode,
            source: route.query.source,
        }),
        meta: {
            breadcrumb: [
                { name: "Home", localizationKey: "homeButton", link: "/" },
                { name: "Credits", link: "/orders/credits" },
                { name: "Details", link: ""}
            ],
        },
    },
    {
        path: "/orders/backorders",
        component: Backorders,
        name: "Backorders",
        meta: {
            breadcrumb: [
                { name: "Home", localizationKey: "homeButton", link: { name: "Home" } },
                { name: "Backorders", localizationKey: "backorders", link: "" },
            ],
        },
    },
    {
        path: "/partsStore/Orders/Index",
        component: PartsStoreOrders,
        name: "partsStoreOrders",
        meta: {
            breadcrumb: [
                { name: "Home", localizationKey: "homeButton", link: "/" },
                { name: "Parts Store Orders", link: "/partsStore/Orders/Index" },
            ],
        },
    },
    {
        path: "/Orders/partsStore/Index", // supporting partsStore/Orders and Orders/partsStore since these were both used in DN6
        component: PartsStoreOrders,
        name: "OrdersPartsStore",
        meta: {
            breadcrumb: [
                { name: "Home", localizationKey: "homeButton", link: "/" },
                { name: "Parts Store Orders", link: "/partsStore/Orders/Index" },
            ],
        },
    },
    {
        path: "/partsStore/Orders/Details",
        component: PartsStoreOrderDetails,
        name: "partsStoreOrderDetails",
        props: (route) => ({
            partsStoreOrderId: route.query.orderId,
            customerId: route.query.customerId, // DN-3897 this route is used by One Bill to link Sunbelt Parts Store Orders
            poNumber: route.query.poNumber,
        }),
        meta: {
            breadcrumb: [
                { name: "Home", localizationKey: "homeButton", link: "/" },
                { name: "Parts Store Orders", link: "/partsStore/Orders/Index" },
                { name: "Details", link: "" },
            ],
        },
    },
    {
        path: "/Orders/partsSTore/Details",
        component: PartsStoreOrderDetails,
        name: "OrdersPartsStoreDetails",
        props: (route) => ({
            orderId: route.query.orderId,
        }),
        meta: {
            breadcrumb: [
                { name: "Home", localizationKey: "homeButton", link: "/" },
                { name: "Parts Store Orders", link: "/partsStore/Orders/Index" },
                { name: "Details", link: "" },
            ],
        },
    },
    {
        path: "/orders/quickorders",
        component: QuickOrders,
        name: "QuickOrders",
        props: (route) => ({
            id: ObjectUtil.findValueByKey(route.query, "partListId")
        }),
        meta: {
            breadcrumb: [
                { name: "Home", localizationKey: "homeButton", link: "/" },
                { name: "Quick Orders", link: { name: "QuickOrders" } }
            ],
        },
    },
    {
        path: "/claimsAndReturns/claims",
        component: ViewClaims,
        name: "ViewClaims",
        meta: {
            breadcrumb: [{ name: "Home", localizationKey: "homeButton", link: "/" }, { name: "View Claims", link: "" }],
        },
    },
    {
        path: "/claimsAndReturns/search",
        component: ClaimsReturnsSearchResults,
        name: "Search",
        props: (route) => ({
            referenceNumber: route.query.referenceNumber,
            partNumber: route.query.partNumber,
            accountId: route.query.accountId,
        }),
        meta: {
            breadcrumb: [{ name: "Home", localizationKey: "homeButton", link: "/" }, { name: "Search", link: "" }],
        },
    },
    {
        path: "/claimsAndReturns/claimDetails",
        component: ClaimDetails,
        name: "ClaimDetails",
        props: (route) => ({
            claimNumber: route.query.claimNumber,
            accountId: route.query.accountId
        }),
        meta: {
            breadcrumb: [
                { name: "Home", localizationKey: "homeButton", link: "/" },
                { name: "View Claims", link: "/claimsAndReturns/claims" },
                { name: "Claim Details", link: "" },
            ],
        },
    },
    {
        path: "/claimsAndReturns/createClaim",
        component: CreateClaim,
        name: "CreateClaim",
    },
    {
        path: "/claimsAndReturns/returns",
        component: ViewReturns,
        name: "ViewReturns",
        meta: {
            breadcrumb: [
                { name: "Home", localizationKey: "homeButton", link: "/" },
                { name: "View Returns", link: "" },
            ],
        },
    },
    {
        path: "/claimsAndReturns/return/:id",
        component: ReturnDetails,
        name: "ReturnDetails",
        props: (route) => ({
            returnId: route.params.id,
            salesOrg: route.query.salesOrg,
            accountId: route.query.accountId,
            returnSource: route.query.returnSource,
        }),
        meta: {
            breadcrumb: [
                { name: "Home", localizationKey: "homeButton", link: "/" },
                { name: "Return Details", link: "" },
            ],
        },
    },
    {
        path: "/claimsAndReturns/createReturn",
        component: CreateReturn,
        name: "CreateReturn",
        props: (route) => ({
            returnId: Number.parseInt(route.query.returnId),
        }),
    },
    {
        path: "/rvsc/index",
        component: ClaimsReturnsMenu,
        name: "Dn6ClaimsReturnsIndex",
        meta: {
            breadcrumb: [
                { name: "Home", localizationKey: "homeButton", link: "/" },
                { name: "Claims & Returns", link: "/claimsAndReturns/index" },
            ],
        },
    },
    {
        path: "/claimsAndReturns/index",
        component: ClaimsReturnsMenu,
        name: "ClaimsReturnsIndex",
        meta: {
            breadcrumb: [
                { name: "Home", localizationKey: "homeButton", link: "/" },
                { name: "Claims & Returns", link: "/claimsAndReturns/index" },
            ],
        },
    },
    {
        path: "/resourceLibrary",
        component: ResourceLibrary,
        name: "ResourceLibrary",
        props: (route) => ({
            currentLabelId: route.query.currentLabelId
        }),
        meta: {
            breadcrumb: [
                { name: "Home", localizationKey: "homeButton", link: "/" },
                { name: "Resource Library", link: "/resourceLibrary" },
            ],
        },
    },
    {
        path: "/reverseLogistics",
        component: ReverseLogistics,
        name: "Reverse Logistics",
       
        children: [
            {
                path: "entitlements",
                component: Entitlements,
                name: "Entitlements",
                meta:{
                    breadcrumb: [
                        { name: "Home", localizationKey: "homeButton", link: "/" },
                        { name: "Entitlements", link: "/Entitlements"}
                    ],
                },
            },   
            {
                path: "ccrRequestForm",
                component: CcrRequestForm,
                name: "CcrRequestForm",
                meta:{
                    breadcrumb: [
                        { name: "Home", localizationKey: "homeButton", link: "/" },
                        { name: "Core Credit Request Form", link: "/ccrRequestForm"}
                    ],
                }
            },
            {
                path: "completeCoreCreditRequest",
                component: CompleteCoreCreditRequest,
                name: "CompleteCoreCreditRequest",
                meta:{
                    breadcrumb: [
                        { name: "Home", localizationKey: "homeButton", link: "/" },
                        { name: "Complete Core Credit Request", link: "/CompleteCoreCreditRequest"}
                    ],
                },
                props: (route) => ({
                    ccrNumber: route.query.ccrNumber,
                    accountId: route.query.accountId.toString(),
                    estimatedShipDate: route.query.estimatedShipDate
                })
            },
            {
                path: "coreCredits",
                component: CoreCredits,
                name: "CoreCredits",
                meta:{
                    breadcrumb: [
                        { name: "Home", localizationKey: "homeButton", link: "/" },
                        { name: "Core Credits", link: "/coreCredits"}
                    ],
                },
            },
            {
                path: "openCCRs",
                component: OpenCoreCreditRequests,
                name: "OpenCoreCreditRequests",
                meta:{
                    breadcrumb: [
                        { name: "Home", localizationKey: "homeButton", link: "/" },
                        { name: "Open Core Credit Requests", link: "/OpenCCRs"}
                    ],
                },
            },
            {
                path: "corePurchaseRequest",
                component: CorePurchaseRequest,
                name: "CorePurchaseRequest",
                meta: {
                    breadcrumb: [
                        { name: "Home", localizationKey: "homeButton", link: "/" },
                        { name: "Claims and Returns", link: "/referseLogistics" },
                        { name: "Core Purchase Request Form", link: "" }
                    ]
                }
            }
        ]
    },
    {
        path: "/news",
        component: News,
        name: "News",
        props: (route) => ({
            storyId: route.query.storyId
        }),
        meta: {
            breadcrumb: [
                { name: "Home", localizationKey: "homeButton", link: "/" },
                { name: "News", link: "/News" }
            ],
        },
    },
    {
        path: "/shopping-cart",
        component: Cart,
        name: "ShoppingCart"
    },
    {
        path: "/thank-you",
        component: ShoppingCartThankYou,
        name: "ShoppingCartThankYou",
        props: true
    },
    {
        path: "/partsearch",
        component: PartSearchPage,
        name: "PartSearchPage",
        props: (route) => ({
            searchTerm: route.query.searchTerm,
            activeView: route.query.activeView
        }),
        meta: {
            breadcrumb: [
                { name: "Home", localizationKey: "homeButton", link: "/" },
                { name: "Part Search Results", link: "/partsearch" }
            ],
        },
    },
    {
        path: "/promotion",
        component: Promotion,
        name: "Promotion",
        props: (route) => ({
            promotionId: route.query.promotionId
        }),
        meta: {
            breadcrumb: [
                { name: "Home", localizationKey: "homeButton", link: "/" },
                { name: "Promotion", link: "/Promotion" }
            ],
        },
    },
    {
        path: "/parts/partDetail",
        component: PartDetails,
        name: "PartDetails",
        props: (route) => ({
            oemPartCode: ObjectUtil.findValueByKey(route.query, "oemPartCode"),
            partId: ObjectUtil.findValueByKey(route.query, "partId"),
            showTab: ObjectUtil.findValueByKey(route.query, "showTab"),
        }),
        meta: {
            breadcrumb: [
                { name: "Home", localizationKey: "homeButton", link: "/" },
                { name: "Part Details", localizationKey: "partDetails", link: { name: "PartDetails" } },
            ],
        },
    },
    {
        path: "/Parts/truckSelection",
        component: TruckSelection,
        name: "TruckSelection",
        props: (route) => ({
            make: route.query.make,
            model: route.query.model,
            category: route.query.category
        })
        // Using custom breadcrumbs for this section
    },
    {
        path: "/Parts/truckModelSearch",
        component: TmsIndex,
        name: "TruckModelSearch",
        props: (route) => ({
            oemDescription: route.query.OemDescription,
            modelName: route.query.Model,
            categoryName: route.query.Category
        }),
        // Using custom breadcrumbs for this section
    },
    {
        path: "/tms/partsLookup",
        component: PartDiagramPage,
        name: "DiagramSearch",
        props: (route) => ({
            oemDescription: route.query.OemDescription,
            modelName: route.query.Model,
            categoryName: route.query.Category
        }),
        // Using custom breadcrumbs for this section
    },
];

const router = new VueRouter({
    routes: routes,
    mode: "history",
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 };
    }
});

export default router;
